import Axios from "axios";
import {
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
  antdAsyncMessageError,
} from "../../helpers/AsyncMessage";
import {
  errorHandler,
} from "../../helpers/Utils";


export const removeOrderActionHistories = async (id) => {
  const key = "removeOrderActionHistories"
  try {
    antdAsyncMessageLoading({
      key,
    });
    const { data } = await Axios.delete(`/api/v1/order_action_histories/${id}`);
    if (!data.success) throw new Error("ERR");
    antdAsyncMessageSuccess({
      key,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({
      key,
    });
    return { success: false };
  }
};
